'use strict';
// https://embed.plnkr.co/plunk/fdkB1W

module.exports = function () {
    return {
        restrict: 'C',
        link: function postLink(scope, iElement, iAttrs) {
            iElement.find('td')
                .mouseover(function () {
                    $(this).parent('tr').css('opacity', '0.7');
                }).mouseout(function () {
                    $(this).parent('tr').css('opacity', '1.0');
                });
        }
    };
};